import { MessageDirection } from '@sharedlib/common/types/mail-app/MessageDirection';
import { MessageState } from '@sharedlib/common/types/mail-app/MessageState';
import { type Message } from '@modules/messages/types/message';
import { getMessageVirtualLocationBadge } from '@modules/messages/utils/message-location-badge';

/** A saved mail folder wins; virtual locations are classified without the search gate. */
export function messageFooterLocation(message: Message | undefined, collection: string | undefined): string {
  if (collection) {
    return collection;
  }
  if (!message || message.archived || message.deleted) {
    return '';
  }
  if (message.spam) {
    return 'Spam';
  }
  if (message.bulk) {
    return 'Bulk';
  }
  if (
    message.direction === MessageDirection.OUTGOING &&
    (message.state === MessageState.READY_TO_SEND || message.state === MessageState.SENDING_WAIT_KNOTS)
  ) {
    return 'Sending';
  }
  const names = { inbox: 'Inbox', sent: 'Sent', draft: 'Drafts', scheduled: 'Scheduled', 'other-mail': 'Other Mail' };
  const location = getMessageVirtualLocationBadge(message);
  return location ? names[location.type] : '';
}
